import { marked } from "marked";

// Articles are first-party content authored by Survantic (seeded / DB-managed),
// so we render their Markdown to HTML directly. GitHub-flavored markdown, no
// auto line-breaks (paragraphs come from blank lines).
marked.setOptions({ gfm: true, breaks: false });

export function renderMarkdown(md: string): string {
  // With the default (non-async) configuration marked.parse returns a string.
  return marked.parse(md) as string;
}
